<template>
	<div class="basic complete">
		<inline-svg :src="require('@/assets/img/icon/complete.svg')" />
		<BaseTitle :title="title()" />
		<BaseInfo :infoList="infoList" />
		<BaseButton
			name="완료"
			bottom="bottom"
			@click="$router.replace({ name: 'Main' })"
		/>
	</div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import BaseTitle from '@/components/Base/BaseTitle';
import BaseInfo from '@/components/Base/BaseInfo';
import BaseButton from '@/components/Base/BaseButton';
import InlineSvg from 'vue-inline-svg';

export default {
	name: 'Complete',
	components: {
		BaseButton,
		BaseInfo,
		BaseTitle,
		InlineSvg,
	},
	setup() {
		const store = useStore();
		const route = useRoute();
		// 예약 완료시 accessToken값 삭제
		store.dispatch('member/CLEAR_ACCESS_TOKEN');

		const infoList = computed(() => {
			const info =
				"셔틀버스 예약내역은 ‘홈화면 > 예약확인하기'에서 확인하실 수 있습니다.";
			const preBookCancelTermText =
				store.getters['common/preBookCancelTermText'];
			const remainBookCancelTermText =
				store.getters['common/remainBookCancelTermText'];
			return [info, preBookCancelTermText, remainBookCancelTermText];
		});

		const title = () => {
			return route.fullPath.includes('etc')
				? '신청이 완료되었습니다'
				: '예약이 완료되었습니다';
		};

		return { infoList, title };
	},
};
</script>
